import type {FleetEvent} from './fleet-events-model';
export type FleetEventsState={rows:FleetEvent[];status:'idle'|'loading'|'ready'|'error';error:string;request:number;from:string;to:string};
export const emptyFleetEvents: FleetEventsState={rows:[],status:'idle',error:'',request:0,from:'',to:''};
type Update={type:'begin';request:number;from:string;to:string}|{type:'result';request:number;rows:FleetEvent[]}|{type:'error';request:number;error:string}|{type:'reset';request:number};
export function fleetEventsReducer(state:FleetEventsState,update:Update):FleetEventsState{
 if(update.type==='reset')return {...emptyFleetEvents,request:update.request};
 if(update.type==='begin')return {...emptyFleetEvents,...update,status:'loading'};
 if(update.request!==state.request)return state;
 if(update.type==='result')return {...state,rows:update.rows,status:'ready',error:''};
 return {...state,rows:[],status:'error',error:update.error};
}
